import React, { useState } from 'react';

import { withStyles, WithTheme } from '@material-ui/core';
import Select, { SelectProps } from 'core/Select';
import { debounce, get, map, omit, sortBy } from 'lodash';
import { usePatientFormMedicationSearch } from 'ui-model';

export type MedicationSearchValues = { value: string; label: string }[];

export interface TextFieldMedicationSearchProps
  extends Omit<SelectProps, 'classes' | 'loadOptions' | 'onChange'>,
    WithTheme {
  onChange: (values: MedicationSearchValues) => void;
  shouldAutoFocus: boolean;
}

const TextFieldMedicationSearch: React.FC<TextFieldMedicationSearchProps> = ({ theme, shouldAutoFocus, ...rest }) => {
  const [loadOptionsParams, setLoadOptionsParams] = useState<{
    search?: string;
    callback?:(options: MedicationSearchValues) => void;
  }>();

  usePatientFormMedicationSearch(
    { search: loadOptionsParams?.search || '' },
    {
      onSettled: (response) => {
        const options = map(response, (medication) => {
          const formattedName = `${medication.drugName} - ${medication.strength}`;
          return {
            label: formattedName,
            value: formattedName,
          };
        });

        const sorttedOptions = sortBy(options, 'label');
        if (loadOptionsParams?.callback) loadOptionsParams.callback(sorttedOptions);
      },
      enabled: !!loadOptionsParams?.search,
    },
  );

  return (
    <Select
      margin="none"
      menuPlacement="top"
      isMulti
      isClearable={false}
      hideNoResults
      hideSelectedOptions
      noAdornment
      shouldAutoFocus={shouldAutoFocus}
      breakWhiteSpace
      TextFieldProps={{
        InputProps: {
          disableUnderline: true,
          // WORKAROUND: We can't pass masked inputs to `react-select` components
          ...omit(get(rest, 'InputProps'), ['inputComponent']),
        },
      }}
      loadOptions={debounce(
        (searchParam, callbackParam) => setLoadOptionsParams({ search: searchParam, callback: callbackParam }),
        300,
      )}
      {...rest}
    />
  );
};

export default withStyles({}, { name: 'TextFieldMedicationSearch', withTheme: true })(TextFieldMedicationSearch);
